import React from "react";
import { useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Button, Input } from "@tyrannosaurustech/ui";
import { NavBar } from "../../components/organisms/NavBar";
import { ContentWrapper } from "../../components/ContentWrapper";
import { CardWrapper as Card } from "../../components/atoms/Card";
import { TitleM, SubtitlesM } from "../../components/atoms/Typography";

export const checkIsCompleteProfileScreen = () =>
  window.location.pathname === "/complete-profile";

const CompleteProfile = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get("email");
  const state = queryParams.get("state");

  const { register, handleSubmit, formState } = useForm({
    mode: "onChange",
    defaultValues: {
      email: email || "",
      name: "",
      state: state || "",
    },
  });

  const onSubmit = (data: any) => {
    window.location.href = `https://login.rayna-app.com/continue?state=${state}&name=${data.name}`;
  };

  return (
    <>
      <NavBar />
      <ContentWrapper
        mainSectionStyle={{ display: "flex", justifyContent: "center" }}
      >
        <div className="flex items-center justify-center h-[calc(100vh-64px)] max-w-[600px]">
          <Card>
            <div className="p-8 min-w-[400px]">
              <TitleM>Complete your Profile</TitleM>
              <SubtitlesM className="mt-4 mb-4">
                Welcome to Rayna, please enter your full name
              </SubtitlesM>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mb-4">
                  <Input
                    label="Email"
                    className="w-full"
                    disabled
                    {...register("email")}
                  />
                </div>
                <div className="mb-4">
                  <Input
                    label="Full Name"
                    placeholder=""
                    required
                    className="w-full"
                    {...register("name", { required: true })}
                  />
                </div>
                <input type="hidden" {...register("state")} />
                <div className="flex justify-center items-center w-full">
                  <Button
                    type="submit"
                    className="w-full"
                    label="Submit"
                    full
                    disabled={!formState.isValid}
                  />
                </div>
              </form>
            </div>
          </Card>
        </div>
      </ContentWrapper>
    </>
  );
};

export default CompleteProfile;
